const ENDPOINT = '/api/statistics';

const STATISTICS_INIT = 'statistics/STATISTICS_INIT';
const STATISTICS_SUCCESS = 'statistics/STATISTICS_SUCCESS';
const STATISTICS_FAILED = 'statistics/STATISTICS_FAILED';

const initialState = {
  data: {},
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case STATISTICS_INIT:
      return {
        data: initialState.data,
        loading: true
      };
    case STATISTICS_SUCCESS: {
      return {
        data: action.payload,
        loading: false
      };
    }
    case STATISTICS_FAILED:
      return {
        data: initialState.data,
        loading: false
      };
    default:
      return state;
  }
}

export function statistics(key, value) {
  return {
    types: [STATISTICS_INIT, STATISTICS_SUCCESS, STATISTICS_FAILED],
    promise: (client) => client.get(`${ENDPOINT}/${key}/${value}`)
  };
}
